import { DBMetadata } from '../../types/shared/db'
import { CervicalExam } from './cervicalExam'
import { Contraction } from './contraction'
import { FetalHeartRateExam } from './fhr'
import { MedicationLog } from './medication'
import { Narrative } from './narrative'
import { Procedure } from './procedure'
import { LaborVitalSigns } from './vitals'

// 30 seconds — intentionally separate from antepartum AUTOSAVE_INTERVAL_MS (60s).
// Patient safety requirement: labor entries must save more frequently than antepartum notes.
export const LABOR_AUTOSAVE_INTERVAL_MS = 30_000

export enum LaborEntryType {
  VITALS = 'vitals',
  CERVICAL_EXAM = 'cervical-exam',
  FHR = 'fhr',
  CONTRACTION = 'contraction',
  MEDICATION = 'medication',
  NARRATIVE = 'narrative',
  PROCEDURE = 'procedure',
}

export type LaborEntryData<Type extends LaborEntryType> = {
  [LaborEntryType.VITALS]: LaborVitalSigns
  [LaborEntryType.CERVICAL_EXAM]: CervicalExam
  [LaborEntryType.FHR]: FetalHeartRateExam
  [LaborEntryType.CONTRACTION]: Contraction
  [LaborEntryType.MEDICATION]: MedicationLog
  [LaborEntryType.NARRATIVE]: Narrative
  [LaborEntryType.PROCEDURE]: Procedure
}[Type]

export interface LaborEntryVersion extends DBMetadata {
  data: LaborEntryData<LaborEntryType>
  /** Optional reason for amendment — populated when entry was edited post-creation */
  amendmentReason?: string
}

export interface LaborEntryBase extends DBMetadata {
  type: LaborEntryType
  startedAt: number
  versionHistory?: LaborEntryVersion[]
}

export type LaborEntry<Type extends LaborEntryType> = LaborEntryBase & {
  data: LaborEntryData<Type>
}

export interface LaborChartingData {
  entries: Record<string, LaborEntry<LaborEntryType>>
}
